import FrequencyPicker from './FrequencyPicker';

export { DEFAULT_FREQUENCY } from './FrequencyPicker';
export default FrequencyPicker;